import { Box, Flex, useColorModeValue } from "@chakra-ui/react";
import { BsArrowUp } from "react-icons/bs";

import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { useGetThemeColors } from "ChakraTheme";

const ButtonUp = () => {
  const colors = useGetThemeColors();
  const primaryBlue = useColorModeValue(colors.primary[600], colors.white);

  const hoverBackgroundColor = useColorModeValue(
    colors.primary[700],
    colors.gray[700]
  );
  const backgroundColor = useColorModeValue("transparent", colors.gray[400]);
  const activeBackgroundColor = useColorModeValue(
    colors.primary[900],
    colors.primary[700]
  );

  const onScrollTop = () => {
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  };
  return (
    <Box
      id="go-to-top-of-page-btn"
      as="button"
      role="group"
      borderRadius={15}
      border={`solid 2px ${primaryBlue}`}
      backgroundColor={backgroundColor}
      _hover={{
        backgroundColor: hoverBackgroundColor,
        color: colors.white,
      }}
      _active={{
        backgroundColor: activeBackgroundColor,
      }}
      color={colors.black}
      onClick={onScrollTop}
    >
      <Flex alignItems="center" px={10} py={4}>
        <Icon
          color={colors.black}
          _groupHover={{ color: colors.white }}
          icon={BsArrowUp}
          mr={1}
        />
        <ChakraText>Do góry</ChakraText>
      </Flex>
    </Box>
  );
};

export { ButtonUp };
